import { render, staticRenderFns } from "./BusinessCard.vue?vue&type=template&id=b54f1bea&scoped=true"
import script from "./BusinessCard.vue?vue&type=script&lang=js"
export * from "./BusinessCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b54f1bea",
  null
  
)

export default component.exports